<script>

	import Card from "../commons/Card.svelte";

</script>
<div class="basis-[400px] flex-grow mx-3 my-2">
  <Card>
    <slot />
  </Card>
</div>